import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AlertCircle } from 'lucide-react';
import theme from '../theme';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS_STYLES = {
  OPEN: { bg: `${theme.colors.primary}15`, color: theme.colors.primary, label: 'Open' },
  UNDER_REVIEW: { bg: `${theme.colors.status.warning}15`, color: theme.colors.status.warning, label: 'Under Review' },
  RESOLVED: { bg: `${theme.colors.status.success}15`, color: theme.colors.status.success, label: 'Resolved' },
  REJECTED: { bg: `${theme.colors.status.error}15`, color: theme.colors.status.error, label: 'Rejected' },
};

const CreatorDisputesPageWorking = () => {
  const navigate = useNavigate();
  const [disputes, setDisputes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDisputes = async () => {
      try {
        const res = await axios.get(`${API}/creator/disputes`);
        setDisputes(res.data || []);
      } catch (err) {
        console.error('Failed to load creator disputes:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchDisputes();
  }, []);

  if (loading) return <div style={{ padding: '40px', color: theme.colors.text.muted }}>Loading disputes...</div>;

  return (
    <div data-testid="creator-disputes-page" style={{ padding: '40px' }}>
      <h1 style={{ fontSize: '28px', fontWeight: 700, color: theme.colors.text.primary, fontFamily: theme.fonts.heading, marginBottom: '8px' }}>
        Disputes
      </h1>
      <p style={{ fontSize: '15px', color: theme.colors.text.secondary, marginBottom: '32px' }}>
        Disputes filed against your portfolios
      </p>

      {disputes.length === 0 ? (
        <div style={{
          background: theme.colors.bg.card, border: `1px solid ${theme.colors.borders}`,
          borderRadius: theme.radius.card, padding: '60px', textAlign: 'center',
        }}>
          <AlertCircle size={40} style={{ color: theme.colors.text.muted, marginBottom: '12px' }} />
          <p style={{ color: theme.colors.text.muted, fontSize: '15px' }}>No disputes filed against your portfolios</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {disputes.map(d => {
            const st = STATUS_STYLES[d.status] || STATUS_STYLES.OPEN;
            return (
              <div key={d.id} data-testid={`creator-dispute-${d.id}`}
                onClick={() => navigate(`/creator/disputes/${d.id}`)}
                style={{
                background: theme.colors.bg.card, border: `1px solid ${theme.colors.borders}`,
                borderRadius: theme.radius.md, padding: '20px', cursor: 'pointer', transition: 'box-shadow 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = theme.colors.shadows.md}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                  <div>
                    <h3 style={{ color: theme.colors.text.primary, fontSize: '16px', fontWeight: 600, marginBottom: '4px' }}>{d.subject}</h3>
                    <p style={{ color: theme.colors.text.muted, fontSize: '13px' }}>
                      {d.dispute_type} | {d.portfolio_name || 'No portfolio'} | By: {d.buyer_email}
                    </p>
                  </div>
                  <span style={{ padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 600, background: st.bg, color: st.color }}>
                    {st.label}
                  </span>
                </div>
                <p style={{ color: theme.colors.text.secondary, fontSize: '14px', lineHeight: '1.5' }}>
                  {d.description.length > 200 ? d.description.slice(0, 200) + '...' : d.description}
                </p>
                <p style={{ color: theme.colors.text.muted, fontSize: '12px', marginTop: '8px' }}>
                  Filed: {new Date(d.created_at).toLocaleDateString()}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CreatorDisputesPageWorking;
